import { emailSchema } from '../../../schemas/common/email.js';
import '../../../schemas/common/url.js';
import '../../../schemas/common/phone.js';
import '../../../schemas/common/dateOfBirth.js';
import { nameSchema } from '../../../schemas/common/name.js';
import '../../../schemas/common/license.js';
import '../../../schemas/common/financial.js';
import '../../../schemas/common/checkbox.js';
import '../../../schemas/common/hours.js';
import '../../../schemas/common/tcpa.js';
import { z } from 'zod';
import { addressSchema } from '../../Address.js';
import { payableDataSchema } from '../../Payable.js';
import { saleServiceConfigSchema, saleServicePricingDtoSchema } from '../configurations/SaleServiceConfig.js';
import { serviceConfigSchema } from '../configurations/SharedServiceConfig.js';
import { servicesProviderGenericDataSchema, agentSchema, supportObjectSchema } from '../ServicesProviderData.js';
import { Services } from './Services.js';

const servicesProviderSaleDataSchema = servicesProviderGenericDataSchema
    .merge(payableDataSchema)
    .extend({
    config: z.object({
        [Services.SALE]: saleServiceConfigSchema,
    }),
    physicalAddress: addressSchema,
    dealerLicenseDocument: z.string(),
    authorizedRepresentativeIdentityDocument: z.string(),
    agents: z.array(agentSchema),
    support: supportObjectSchema,
});
// ============================================================================
// DTO Schema for Sale Service Configuration
// ============================================================================
// This DTO schema is used for form validation and API requests.
// It includes pricing as an array (like assembly service) and primaryContractSigner (agent).
const servicesProviderSaleServiceDtoSchema = serviceConfigSchema.extend({
    licenseNumber: z.string().trim().min(1, 'licenseNumber is required'),
    pricing: z.array(saleServicePricingDtoSchema),
    primaryContractSigner: z
        .object({
        firstName: nameSchema,
        middleName: nameSchema.nullable().or(z.literal('')),
        lastName: nameSchema,
        email: emailSchema,
    })
        .optional(),
});

export { servicesProviderSaleDataSchema, servicesProviderSaleServiceDtoSchema };
//# sourceMappingURL=ServicesProviderSaleData.js.map
